import IconBrand from '@/fo/icons/base/icons/smile_white.svg';
import { UiKitLabelBase } from '@/fo/ui/kit/label/base';

import { formattedPoints, type PointsSign } from '../utils/formattedPoints';

import { styles } from './UiLoyaltyLabelBase.styles';

export type UiLoyaltyLabelBaseProps = {
  points: number;
  sign?: PointsSign;
  lang?: string;
  className?: string;
};

export const UiLoyaltyLabelBase = ({
  points,
  sign = 'none',
  lang,
  className
}: UiLoyaltyLabelBaseProps) => {
  const slots = styles();

  return (
    <UiKitLabelBase
      color="gr"
      className={slots.base({ className })}
    >
      {formattedPoints(points, sign, lang)}
      <IconBrand className={slots.icon()} />
    </UiKitLabelBase>
  );
};
